import React from 'react';
import api from 'api';
import { Modal, NumberInput, DropdownSelector, DatePicker } from 'hyperdb-utils';

class ModalForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  render() {
    return (
      <Modal title={ this.props.title } onClose={ this.props.onCancel } onAccept={ this.handleSubmit } loading={ this.props.loading }>
        <fieldset>
          <NumberInput
            label="Amount"
            name="amount"
            value={ this.props.objectData.amount }
            onChange={ this.handleChange.bind(this, 'amount') }
          />
          <DropdownSelector
            label="Method"
            name="payment_method"
            options={ this.methodsOptions() }
            value={ this.props.objectData.payment_method }
            onChange={ this.handleChange.bind(this, 'payment_method') }
          />
          <DatePicker
            label="Transaction date"
            name="transaction_date"
            value={ this.props.objectData.transaction_date }
            onChange={ this.handleChange.bind(this, 'transaction_date') }
          />
          <DatePicker
            label="Value date"
            name="value_date"
            value={ this.props.objectData.value_date }
            onChange={ this.handleChange.bind(this, 'value_date') }
          />
        </fieldset>
      </Modal>
    );
  }
  methodsOptions() {
    return ['card', 'transfer', 'cash', 'check', 'card_online', 'paypal', 'bitcoin'].map(m => {
      return { name: m, value: m };
    });
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.api.payment.updateEditedObject({ attributeName, value });
  }
  handleSubmit() {
    const payment = { ...this.props.objectData };
    payment.reservation = { $type: 'reference', external: true, value: ['reservations', this.props.reservation.id] };
    payment.customer = { $type: 'reference', external: true, value: ['customers', this.props.reservation.customer.id] };
    this.props.onSubmit(payment);
  }
}

export default api.connect(ModalForm, 'payment', { noClearOnUnmount: true });

ModalForm.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  reservation: React.PropTypes.object,
  title: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/payment/containers/ModalForm.jsx